export default __webpack_public_path__ + "static/media/project4.8424bff0.webp";